import { combineReducers } from 'redux';

import createReducer from 'utils/createReducer';
import { SET_INVENTORY_FEATURE_FLAG } from './types';

const listInventoryFeature = createReducer([], {
  [SET_INVENTORY_FEATURE_FLAG]: (_, { payload }) => {
    return payload;
  },
});

export default combineReducers({
  listInventoryFeature,
});
